import React from "react";
import { FaShieldAlt, FaExchangeAlt, FaCode, FaGasPump } from "react-icons/fa";

function MajorFunctionalities() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Major Functionalities of Ethereum Wallet
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaShieldAlt size={40} />
                  </div>
                  <h4>Secure Storage For ETH and Tokens</h4>
                  <p>
                    Safely stores Ether (ETH) and Ethereum-based tokens (ERC-20,
                    ERC-721), ensuring secure access through encryption and
                    private key management.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaExchangeAlt size={40} />
                  </div>
                  <h4>Sending & Receiving Assets</h4>
                  <p>
                    Facilitates the easy transfer of Ether and tokens between
                    users by sending and receiving funds with simple address
                    inputs and real-time confirmations.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaCode size={40} />
                  </div>
                  <h4>Interaction with Smart Contracts & dApps</h4>
                  <p>
                    Enables users to interact with Ethereum smart contracts and
                    decentralized applications (dApps) for activities like DeFi,
                    NFTs, and token swaps directly from the wallet.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaGasPump size={40} />
                  </div>
                  <h4>Custom Gas Fee Management</h4>
                  <p>
                    Allows users to set and adjust gas fees for transactions,
                    optimizing speed and cost based on network conditions and
                    user preferences.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MajorFunctionalities;
